import { render, staticRenderFns } from "./ElIconBox.vue?vue&type=template&id=41691084"
import script from "./ElIconBox.vue?vue&type=script&lang=js"
export * from "./ElIconBox.vue?vue&type=script&lang=js"
import style0 from "./ElIconBox.vue?vue&type=style&index=0&id=41691084&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports